import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error Untyped import
import { selectCustomReportsCount } from 'dashboard-lib/public/reports';
// @ts-expect-error Untyped import
import { selectCustomReportsLimit } from 'dashboard-lib/public/userInfo/limits';
// @ts-expect-error Untyped import
import { getAttributionReportScopeReq } from 'dashboard-lib/public/userInfo/scopes';
// @ts-expect-error Untyped import
import { selectViewReportProblem } from 'dashboard-lib/public/userInfo/permissions/reportActions';
// @ts-expect-error Untyped import
import { CUSTOM_REPORT_COUNT } from 'dashboard-lib/private/action-problem-solution/params/all-params';
// @ts-expect-error Untyped import
import { CUSTOM_REPORT_LIMIT } from 'dashboard-lib/private/action-problem-solution/params/all-params';
// @ts-expect-error Untyped import
import { getViewReportDisabledMessage } from 'dashboard-components/disabled-message/actions/view-report';
// @ts-expect-error Untyped import
import { getRestrictedFieldLevelProperties } from 'reporting-action-components/data/schemas/reportSchema';
// @ts-expect-error Untyped import
import { MARKETING_HUB_UPGRADE_REQUIRED } from 'dashboard-lib/private/action-problem-solution/params/all-params';
// @ts-expect-error Untyped import
import { RESTRICTED_FIELD_LEVEL_PROPERTIES } from 'dashboard-lib/private/action-problem-solution/params/all-params';
// @ts-expect-error Untyped import
import useReportTypeProblem from 'reporting-action-components/reportingActions/shared/problemHooks/useReportTypeProblem';
import { jsx as _jsx } from "react/jsx-runtime";
export const useReportLinkProblem = report => {
  const reportAccessProblem = useReportTypeProblem({
    report
  });
  const viewReportProblem = useSelector(selectViewReportProblem(report));
  const customReportCount = useSelector(selectCustomReportsCount);
  const customReportLimit = useSelector(selectCustomReportsLimit);
  let problem = null;
  let TooltipMessage = null;
  if (reportAccessProblem && reportAccessProblem !== 'LOADING') {
    problem = reportAccessProblem;
    if (reportAccessProblem === 'LACKS_DATASETS_READ') {
      TooltipMessage = () => /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reports.errors.datasetsReadAccessDenied"
      });
    } else {
      TooltipMessage = () => /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reports.errors.dataTypeAccessDenied.tooltip"
      });
    }
  }
  if (viewReportProblem && !reportAccessProblem) {
    const attributionScopeRequirement = getAttributionReportScopeReq(report);
    const restrictedFieldLevelProperties = getRestrictedFieldLevelProperties(report);
    problem = viewReportProblem;
    TooltipMessage = getViewReportDisabledMessage({
      [CUSTOM_REPORT_COUNT]: customReportCount,
      [CUSTOM_REPORT_LIMIT]: customReportLimit,
      [MARKETING_HUB_UPGRADE_REQUIRED]: attributionScopeRequirement,
      [RESTRICTED_FIELD_LEVEL_PROPERTIES]: restrictedFieldLevelProperties
    }, viewReportProblem);
  }
  return {
    problem,
    TooltipMessage
  };
};